<template>

 
      <div>
   
           <b-table 
                            
                            :data="isEmpty ? [] : lab_HIS_LIS_Mapping.bf"
                            bordered 
                            striped 
                            hoverable 
                            mobile-cards >


                                    <b-table-column  label="Abbreviation"   v-slot="props">
                                        {{ getNameFullnameFromFieldKey_CBC(props.row.field_name).nick_name }}
                                    </b-table-column>

                                    <b-table-column  label="Parameter"   v-slot="props">
                                        {{ getNameFullnameFromFieldKey_CBC(props.row.field_name).full_name }}
                                    </b-table-column>

                                    <b-table-column  label="Value"  v-slot="props"   >
                                          <b-input type="number"
                                                v-model="props.row.val"
                                        ></b-input>
                                    </b-table-column>



                                    <b-table-column  label="Unit"  v-slot="props" >
                                       <b-input v-model="props.row.unit"  ></b-input> 
                                    </b-table-column>


                                    <b-table-column  label="Ref."  v-slot="props" >
                                       <b-input   v-model="props.row.ref"  ></b-input>
                                    </b-table-column>



                                    <b-table-column  label="Flag"  v-slot="props"  >
                                       <b-input v-model="props.row.flag"  ></b-input> 
                                    </b-table-column>

                                    <b-table-column  label="Machine ID"  v-slot="props"  >
                                       <b-input v-model="props.row.machine_id"  ></b-input> 
                                    </b-table-column>



                            <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                            </template>



                </b-table>    
    </div>
</template>


<script>
import { mapState} from "vuex";
import getNameFullnameFromFieldKey_CBC from '../../../mixins/methods/getNameFullnameFromFieldKey_CBC'


export default {
    name : "BodyFluidParam",
    mixins:[getNameFullnameFromFieldKey_CBC,],
    mounted(){
 
    },
    computed:{
            ...mapState({
                lab_HIS_LIS_Mapping: state => state.manually_create_lab_automate.lab_HIS_LIS_Mapping ,
                mapField_Fullname : state => state.manually_create_lab_automate.mapField_Fullname ,
                dataToEdit_ManuallyLabAutomate: state => state.manually_create_lab_automate.dataToEdit_ManuallyLabAutomate ,
            }),
         
   

    },
    data(){
        return {
           
            isEmpty : false,
   
        }
    }
}
</script>